module.exports = __webpack_public_path__ + "static/media/Congrats_800.82d6f89d.gif";